/**
 * Determines whether a checkout companion guest is still "incomplete" and should
 * therefore keep the companions step's "Continue" button disabled.
 *
 * @param {{ contact?: { first_name?: string | null }, items?: Array<{ product?: { type?: string } }> }} guest
 * @param {{ hasCompanionForm: boolean, orderType: string, allTicketsSoldOut: boolean }} context
 * @returns {boolean} true when the companion is incomplete and must block progression
 */
export function isCompanionIncomplete(
  guest,
  { hasCompanionForm, orderType, allTicketsSoldOut },
) {
  if (hasCompanionForm && !guest.contact?.first_name) {
    return true
  }

  if (orderType === 'add-ons') {
    return false
  }

  if (allTicketsSoldOut) {
    return false
  }

  return !guest.items?.some(({ product }) => product?.type === 'ticket')
}
